import React from 'react'
import styled from 'styled-components'
import utmLinkGenerator from '../../../utils/UTMLinkGenerator'
import { SIZES } from '../../../../constants'

const Container = styled.a`
  position: relative;
  display: flex;
  align-items: flex-end;
  padding-left: 26px;
  white-space: nowrap;

  &:hover {
    text-decoration: none;
  }

  @media (max-width: ${SIZES.BREAKPOINT_MD - 1}px) {
    margin-bottom: 15px;
  }


  @media (min-width: ${SIZES.BREAKPOINT_MD - 1}px) {
    max-width: 430px;
  }

  @media (max-width: ${SIZES.BREAKPOINT_XS - 1}px) {
    padding-left: 0;
  }
`

const Image = styled.img`
  position: absolute;
  width: 48px;
  height: 35px;
`

const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 51px;
  padding-top: 5px;
  background-size: 19px 27px;

  p {
    margin: 0;
  }
`

const BoldText = styled.p`
  font-weight: bold;
  color: ${props => props.theme.header.cookinglink.darkColor};
  font-size: 13px; 
  line-height: 16px; 
`

const ColorfulText = styled.p`
  color: ${props => props.theme.header.cookinglink.color};
  font-size: 12px;
  font-weight: 400;

  &:after {
    content: '';
    background: url('${STATICS_PATH}images/cookinglink/promo_arrow.svg') left top no-repeat;
    background-size: cover;
    width: 14px;
    Height: 14px;
    display: inline-block;
    margin-left: 5px;
    vertical-align: sub;
  }
`

const CookingLink = ({ widget }) => {
  const {
    utmMedium,
    link,
    src
  } = widget

  return (
    <Container href={utmLinkGenerator.createLink(link, {
      utmMedium
    })}>
      <Image src={`${STATICS_PATH}${src}`} alt='Houbařský speciál'/>
      <TextContainer>
        <BoldText>Houbařský speciál</BoldText>
        <ColorfulText>Co všechno se dá dělat s houbami</ColorfulText>
      </TextContainer>
    </Container>
  )
}

export default CookingLink
